import { httpInstance } from "@/services/httpInstance";
import type { CommerceDgiiInfo } from "./types";

const commerceDgiiInfoEndpoint = "commerce-account/v1/account/info-rnc/v2";

export const getCommerceDgiiInfoService = async (
  documentNumber: string
): Promise<CommerceDgiiInfo | null> => {
  try {
    const response = await httpInstance.get<CommerceDgiiInfo>(
      `${commerceDgiiInfoEndpoint}/${documentNumber.trim()}`
    );

    return response.data || null;
  } catch (error) {
    return null;
  }
};
